import { AlertTriangle } from "lucide-react";
import React from "react";

import { Button } from "@/components/ui/button";
import { apiErrorText } from "@/lib/scan-ui/screen";

/** Ошибка ОБНОВЛЕНИЯ при уже показанных данных: без неё экран молча остаётся
 *  на старых цифрах и выглядит актуальным. */
export function RefetchError({
  error,
  onRetry,
}: {
  error: unknown;
  onRetry: () => void;
}): React.ReactElement {
  return (
    <div
      role="alert"
      className="flex flex-wrap items-center gap-2 rounded-md border border-rose-200 bg-rose-50 p-2 text-sm text-rose-700"
    >
      <AlertTriangle className="size-4 shrink-0" />
      <span>
        Не удалось обновить, показаны прежние данные: {apiErrorText(error, "ошибка загрузки")}
      </span>
      <Button variant="outline" size="sm" onClick={onRetry}>
        Повторить
      </Button>
    </div>
  );
}
